export default {"src":"/_next/static/media/0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};